 <template>
    <b-row>
        <b-col
            md="3"
            cols="12"
            v-for="(item, idx) in pageItems"
            :key="'item-no-' + idx"
        >
            <slot :item="item"></slot>
        </b-col>
    </b-row>
</template>
 <script>
export default {
    props: ['items', 'perPage', 'currentPage'],
    computed: {
        pageItems() {
            const startIndex = (this.currentPage - 1) * this.perPage
            const endIndex =
                this.items.length > startIndex + this.perPage
                    ? startIndex + this.perPage
                    : this.items.length
            return this.items.slice(startIndex, endIndex)
        },
    },
}
</script>
